export default [
{
    path: '/build-your-team',
    name: 'build-your-team',
    component: () => import ('source/pages/build-your-team/BuildYourTeamPage.vue'),
    meta: {
        title: 'HQZen - Build Your Team'
    }
}];
